export default "__VITE_ASSET__BKTNs2Wm__"